import { useState } from "react";
import { Link } from "@tanstack/react-router";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { agreePolicy, setAgreedPolicy, POLICY_CONTENT } from "@/lib/boide-api";

export function PolicyAgreementDialog({ username }: { username: string }) {
  const [agreeing, setAgreeing] = useState(false);
  const [open, setOpen] = useState(true);

  const handleAgree = async () => {
    setAgreeing(true);
    try {
      await agreePolicy(POLICY_CONTENT);
      setAgreedPolicy(username);
      setOpen(false);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Không thể ghi nhận đồng ý chính sách");
    } finally {
      setAgreeing(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        aria-describedby="policy-agreement-description"
        className="flex max-h-[88dvh] w-[calc(100vw-1.5rem)] flex-col gap-0 overflow-hidden rounded-2xl p-0 sm:max-w-lg [&>button.absolute]:hidden"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="border-b border-border/70 px-5 py-5 text-left sm:px-6">
          <DialogTitle className="font-display text-xl leading-tight text-gold-gradient sm:text-2xl">
            Chính sách &amp; điều khoản
          </DialogTitle>
          <DialogDescription
            id="policy-agreement-description"
            className="font-serif-soft leading-6 italic"
          >
            Vui lòng đọc và đồng ý để tiếp tục sử dụng Bói Đê.
          </DialogDescription>
        </DialogHeader>

        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-5 py-5 sm:px-6">
          <p className="text-sm leading-6 text-muted-foreground">{POLICY_CONTENT}</p>

          <p className="text-sm leading-6 text-muted-foreground">
            Xem chi tiết tại{" "}
            <Link
              to="/privacy"
              target="_blank"
              rel="noreferrer"
              className="text-primary underline underline-offset-2"
            >
              Chính sách bảo mật
            </Link>{" "}
            và{" "}
            <Link
              to="/terms"
              target="_blank"
              rel="noreferrer"
              className="text-primary underline underline-offset-2"
            >
              Điều khoản sử dụng
            </Link>
            .
          </p>
        </div>

        <DialogFooter className="border-t border-border/70 bg-background px-5 py-4 sm:px-6">
          <Button onClick={handleAgree} disabled={agreeing} className="w-full sm:w-auto">
            {agreeing ? "Đang xử lý..." : "Tôi đã đọc và đồng ý"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
